import {JackpotWidgetDefaultBox} from './jackpot-widget.default.box';
import {styledByTheme} from '../../../themes/architecture/styled-by-theme';

export const JackpotWidgetBox = styledByTheme(JackpotWidgetDefaultBox).apply();